import jstz from 'jstz'
import Cookies from 'js-cookie'

Cookies.set('browser_time_zone', jstz.determine().name())
